// Module
var code = "<div id=\"V-5F970758-812F-42B9-AA9A-FB5802C57E74\"> <div data-b-component=\"tab\" data-b-comp-items=\"{Binding items}\" data-b-comp-selecteditem=\"{Binding selectedItem}\"> <div class=\"tabheader\"> {Binding title} </div> </div> </div> ";
// Exports
export default code;